import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import { transferAttendedCall, transferBlindCall } from 'flow/actions/phone-actions';
import { selectExtension } from 'flow/selectors/ExtensionSelectors';
import { getKeyboardShortcuts } from 'flow/selectors/keyboard-shortcuts-selectors';
import { getFixedNumberFromExtension, getMobileNumberFromExtension } from 'flow/utils/extension-utils';
import { isMacOs } from 'flow/utils/os-utils-flow';
import { normalizeShortcut } from 'flow/utils/shortcut-utils';
import { useAppDispatch } from './useRedux';
var checkShortcutMatch = function checkShortcutMatch(event, shortcut) {
  var normalizedShortcut = normalizeShortcut(shortcut);
  var keys = normalizedShortcut === null || normalizedShortcut === void 0 ? void 0 : normalizedShortcut.split('+').map(function (key) {
    return key.trim().toLowerCase();
  });
  var keyPressed = event.key.toLowerCase();
  var isModifierKey = function isModifierKey(key) {
    switch (key) {
      case 'cmdorctrl':
      case 'cmd':
      case 'ctrl':
      case 'control':
        return event.metaKey || event.ctrlKey;
      case 'shift':
        return event.shiftKey;
      case 'alt':
        return event.altKey;
      case 'altgraph':
        return event.getModifierState('AltGraph');
      default:
        return false;
    }
  };
  var hasAllModifiers = keys === null || keys === void 0 ? void 0 : keys.filter(function (key) {
    return key !== keyPressed;
  }).every(isModifierKey);
  return hasAllModifiers && keys.includes(keyPressed);
};
var matchingShortcuts = function matchingShortcuts(shortcuts, group, event) {
  return shortcuts.filter(function (s) {
    return s.get('group') === group && checkShortcutMatch(event, s.get('value')) && s.get('enabled');
  });
};
var cmdOrCtrl = function cmdOrCtrl() {
  return isMacOs() ? 'CMD' : 'CTRL';
};
var handleOpenTransferModal = function handleOpenTransferModal(_dispatch, event, props) {
  event.stopPropagation();
  props.setTransferSelectionDialogOpen(true);
};
var handleBlindTransferFixed = function handleBlindTransferFixed(dispatch, _event, props) {
  var fixedNumber = getFixedNumberFromExtension(props.extension);
  if (fixedNumber) {
    dispatch(transferBlindCall(fixedNumber, 'keyboard shortcut ' + "B + ".concat(cmdOrCtrl())));
  }
};
var handleBlindTransferMobile = function handleBlindTransferMobile(dispatch, _event, props) {
  var mobileNumber = getMobileNumberFromExtension(props.extension);
  if (mobileNumber) {
    dispatch(transferBlindCall(mobileNumber, 'keyboard shortcut ' + "B + ".concat(cmdOrCtrl())));
  }
};
var handleAttendedTransferFixed = function handleAttendedTransferFixed(dispatch, _event, props) {
  var fixedNumber = getFixedNumberFromExtension(props.extension);
  if (fixedNumber) {
    dispatch(transferAttendedCall(fixedNumber, props.entityKey, 'keyboard shortcut ' + "A + ".concat(cmdOrCtrl())));
  }
};
var handleAttendedTransferMobile = function handleAttendedTransferMobile(dispatch, _event, props) {
  var mobileNumber = getMobileNumberFromExtension(props.extension);
  if (mobileNumber) {
    dispatch(transferAttendedCall(mobileNumber, props.entityKey, 'keyboard shortcut ' + "A + ".concat(cmdOrCtrl())));
  }
};
var actions = {
  '1': handleAttendedTransferFixed,
  '2': handleAttendedTransferMobile,
  '3': handleBlindTransferFixed,
  '4': handleBlindTransferMobile,
  '5': handleOpenTransferModal
};

// These read the store when the key is pressed, not when the caller rendered.
var runShortcutsOfGroup = function runShortcutsOfGroup(group, event, props) {
  return function (dispatch, getState) {
    var state = getState();
    var actionProps = _objectSpread(_objectSpread({}, props), {}, {
      extension: selectExtension(state, props.entityKey)
    });
    matchingShortcuts(getKeyboardShortcuts(state), group, event).forEach(function (shortcut) {
      actions[shortcut.get('keyboardShortcutEntityId')](dispatch, event, actionProps);
    });
  };
};
var isShortcutOfGroup = function isShortcutOfGroup(group, event) {
  return function (_dispatch, getState) {
    return matchingShortcuts(getKeyboardShortcuts(getState()), group, event).size > 0;
  };
};
var useKeyboardShortcuts = function useKeyboardShortcuts() {
  var dispatch = useAppDispatch();
  var callActionByGroup = useCallback(function (group, event, props) {
    dispatch(runShortcutsOfGroup(group, event, props));
  }, [dispatch]);
  var callSearchShortcut = useCallback(function (group, event) {
    return dispatch(isShortcutOfGroup(group, event));
  }, [dispatch]);
  return {
    callActionByGroup: callActionByGroup,
    callSearchShortcut: callSearchShortcut
  };
};
export default useKeyboardShortcuts;